// レアリティ — 追加時はここに足すだけ
export type SpiritRarity = "N" | "R" | "SR" | "UR";

export const SPIRIT_RARITY_COLORS: Record<SpiritRarity, string> = {
  N:   "#94a3b8", // グレー
  R:   "#60a5fa", // ブルー
  SR:  "#c084fc", // パープル
  UR: "#fbbf24", // ゴールド
};

export const SPIRIT_RARITY_LABELS: Record<SpiritRarity, string> = {
  N:   "ノーマル",
  R:   "レア",
  SR:  "スーパーレア",
  UR: "ウルトラレア",
};

export const SPIRIT_GENRE_LABELS: Record<string, string> = {
  fantasy:   'ファンタジー',
  sf:        'SF',
  horror:    'ホラー',
  mystery:   'ミステリー',
  romance:   'ロマンス',
  comedy:    'コメディ',
  literary:  '文芸',
  adventure: '冒険',
  action:    'アクション',
};

/**
 * ユーザーが所持する精霊インスタンス。
 * 外見・スキル等のマスタデータは Firestore の spiritMaster/{spiritId} を参照。
 */
export interface Spirit {
  id: string;
  spiritId: string;            // spiritMaster/{spiritId} への参照キー
  name: string;                // 表示名
  genre: string;               // ジャンル属性 (fantasy / horror / scifi / ...)
  rarity: SpiritRarity;
  level: number;
  exp: number;
  maxExp: number;              // 次レベルまでの必要経験値
  currentEvolution: number;   // 現在の進化段階 (0 = 未進化)
  maxEvolutions: number;      // 最大進化回数
  canCrossEvolve: boolean;    // 転進化可否
  crossEvolveGenres: string[]; // 転進化先ジャンル一覧
  isActive: boolean;
  imageUrl?: string;           // Firebase Storage URL（未設定時はプレースホルダー）
  avatarType?: 'image' | 'video'; // メディア種別（未設定時は 'image'）
  createdAt: Date;

  // 旅立ちシステム
  isOnAdventure?: boolean;
  adventureStartedAt?: string;       // ISO string
  adventureReturnAt?: string;        // ISO string
  adventureDestinationGenre?: string;
  adventureDurationHours?: number;
  totalAdventureCount?: number;
  hasRareSkill?: boolean;            // UR限定スキル（解放確率1.5倍）
  skills?: import("./skill").SpiritSkill[];
  skillSlots?: number;
}
